import axios from "axios";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import { product_option_load } from "../../../../Component/Interface/Live";
import url from "../../../../Component/server";
import { Icon, RowView } from "../../../../Component/style/common_style";

const OptionBox_list = forwardRef(
  (
    {
      isNotModi,
      isOpen,
      product_seq,
      updateChnage,
    }: {
      isNotModi: boolean;
      isOpen: boolean;
      product_seq: number;
      updateChnage: () => void;
    },
    ref
  ) => {
    const [list, setList] = useState<product_option_load[]>([]);
    const [modiList, setModiList] = useState<product_option_load[]>([]);

    const get_product_option_info = async () => {
      axios
        .get(url.Communication_url.product_option_info, {
          params: { product_seq: product_seq },
        })
        .then((res) => {
          setList(res.data.options || []);
        })
        .catch((err) => {
          console.error(err);
          setList([]);
        });
    };
    useEffect(() => {
      if (isOpen) {
        get_product_option_info();
      }
    }, [isOpen]);

    const setting_init_cnt = (idx: number, newCount: number) => {
      const updatedList = list.map((item, i) =>
        i === idx ? { ...item, init_cnt: newCount } : item
      );
      const modi_item = updatedList[idx];

      setList(updatedList);
      setModiList((prev) => {
        const isAlreadyModi = prev.some((item) => item.seq === modi_item.seq);
        if (isAlreadyModi) {
          // 기존 수정 업뎃
          return prev.map((item) =>
            item.seq === modi_item.seq ? modi_item : item
          );
        } else {
          // 새로운 수정 추가
          return [...prev, modi_item];
        }
      });
    };

    const apply_API = async () => {
      if (modiList.length === 0) {
        return;
      }
      if (isNotModi) {
        alert("판매/판매노출 상품의 상태는 수정할 수 없습니다.");
        return;
      }
      try {
        const modiListWithoutExtraFields = modiList.map(
          ({ product_seq, current_cnt, ...rest }) => rest
        );
        const res = await api.post(
          url.Communication_url.product_option_save,
          {
            product_seq: product_seq,
            option_list: modiListWithoutExtraFields,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        if (res.data.includes("성공")) {
          alert("적용되었습니다.");
          setModiList([]);
          get_product_option_info(); // 상품 옵션 list reload(추후 set으로 변경)
          updateChnage(); // 상품 list reload
        }
      } catch (error) {
        console.error("데이터 수정 실패:", error);
      }
    };

    const delect_product_option = async (seq: number) => {
      if (isNotModi) {
        alert("판매/판매노출 상품의 상태는 수정할 수 없습니다.");
        return;
      }
      try {
        const res = await api.delete(
          url.Communication_url.product_option_delete,
          {
            data: { seq: seq },
            headers: { "Content-Type": "application/json" },
          }
        );
        if (res.data.includes("성공")) {
          alert("삭제 되었습니다.");
          get_product_option_info(); // 상품 옵션 list reload(추후 set으로 변경)
          updateChnage(); // 상품 list reload
        }
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };

    useImperativeHandle(ref, () => ({ get_product_option_info }));

    return (
      <>
        <ModiBox>
          <RowView className="title">
            <div>옵션1</div>
            <div>옵션2</div>
            <div>재고</div>
            <div className="stock">남은 재고</div>
          </RowView>

          <List>
            {list.length === 0 ? (
              <NoneData>옵션을 선택해주세요.</NoneData>
            ) : (
              list.map((data, idx) => {
                return (
                  <OptionData key={idx}>
                    <input value={data.option1} disabled />
                    <input value={data.option2} disabled />
                    <input
                      type="number"
                      min={0}
                      value={data.init_cnt}
                      onChange={(e) =>
                        setting_init_cnt(idx, Number(e.target.value))
                      }
                    />
                    <div>{data.current_cnt}</div>
                    <Icon
                      src={require("../../../../Image/ic_x_white.png")}
                      onClick={() => delect_product_option(data.seq)}
                    />
                  </OptionData>
                );
              })
            )}
          </List>
        </ModiBox>

        <Btn
          className={modiList.length === 0 ? "gray" : "red"}
          onClick={apply_API}
        >
          적용하기
        </Btn>
      </>
    );
  }
);
export default OptionBox_list;

const ModiBox = styled.div`
  padding: 1rem;
  padding-bottom: 0;
  margin-top: 0.5rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px 8px 0 0;
  div.stock {
    margin-right: 2rem;
  }
`;
const OptionData = styled(RowView)`
  margin-bottom: 0.5rem;
  input {
    flex: 1;
    width: 100%;
    margin-right: 0.5rem;
    padding: 0.7rem 1rem;
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    &:hover,
    &:focus {
      border: 1px solid #1d1d1d;
    }
    &:disabled:hover {
      border: 1px solid #f0f0f0;
      cursor: default;
    }
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  div {
    width: 5rem;
    color: #ea2922;
    text-align: center;
  }
  img {
    width: 12px;
    padding: 5px;
    margin-right: 0.5rem;
    background-color: #8e8e8e;
    border-radius: 50px;
    cursor: pointer;
  }
`;
const List = styled.div`
  margin-top: 0.5rem;
  height: 28rem;
  overflow: auto;
  @media ${({ theme }) => theme.modal} {
    max-height: 10rem;
  }
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f0f0f0;
  }
  &::-webkit-scrollbar-thumb {
    background: #c6c6c6;
    &:hover {
      background: #ababab;
    }
  }
`;
const NoneData = styled.div`
  text-align: center;
  padding-top: 5rem;
  color: #8e8e8e;
`;
const Btn = styled.div`
  padding: 1rem 0;
  text-align: center;
  border-radius: 0 0 8px 8px;
  &.red {
    background: linear-gradient(135deg, #7955f0, #3209b9);
    color: white;
  }
  &.gray {
    background-color: #f0f0f0;
    color: #c6c6c6;
  }
`;
